import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'

import configureAppStore from "./store";

const preloadedState = {
   row: {
      selected: 'design_header_0'
   },
   design: {
      header: [],
      body: [],
      footer: [],
      folder: "assets_01",
      catalogue: {
         header: { },
         footer: { }
      },
      designs: {}
   }
};

const store = configureAppStore(preloadedState);

const root = createRoot(document.getElementById('root'));
root.render(
   <Provider store={store}>
      <App />
   </Provider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
